'use client';

import { useLanguage } from '@bells/core/i18n';
import { allCountries, attendantTravelCountries } from '@bells/i18n';
import { AttendantSearchSingleResponse } from '@bells/schema/models/attendant';
import { Badge } from '@bells/ui/components/badge';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@bells/ui/components/card';

import countries from '@bells/iso/countries';
import { Globe } from 'lucide-react';
import { FlagIcon } from '@bells/ui/components/flag-icon';

export const GirlTravelCountries = ({
  data,
}: {
  data?: AttendantSearchSingleResponse;
}) => {
  const { language } = useLanguage();

  return (
    data &&
    data.travelReadyCountries && (
      <Card className='m-0 w-full border-0 bg-transparent p-0 shadow-none'>
        <CardHeader className='px-0'>
          <h3 className='font-semibold leading-none tracking-tight'>
            {attendantTravelCountries()}
          </h3>
        </CardHeader>
        <CardContent className='flex w-full flex-col gap-6 space-y-4 px-0'>
          {!Array.isArray(data.travelReadyCountries) &&
          data.travelReadyCountries === 'all' ? (
            <Badge className='break-all text-base font-normal'>
              {allCountries(language)}
            </Badge>
          ) : (
            <div className='inline-flex flex-wrap gap-2 font-medium'>
              {data.travelReadyCountries?.map((df) => {
                return (
                  <Badge
                    className='flex flex-wrap items-center gap-2 break-all text-[14px] font-normal'
                    key={df}
                  >
                    {df === 'all' ? (
                      <Globe className='h-4 w-4' />
                    ) : (
                      <FlagIcon
                        countryCode={df.toUpperCase()}
                        className='h-4 w-4'
                        alt={countries[df].names[language]}
                      ></FlagIcon>
                    )}
                    {df === 'all'
                      ? allCountries(language)
                      : countries[df].names[language]}
                  </Badge>
                );
              })}
            </div>
          )}
        </CardContent>
      </Card>
    )
  );
};
